import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, GooglePhotosIcon, ExpandBoxIcon} from '@taopix/taopix-design-system';
import {CreateSessionResponse} from '../RemoteAssetService';
import GPDesktopImage from '../../../Images/GPDesktop.png';

export type GoogleDialogInlineProps = {
  isGoogle: boolean;
  open: boolean;
  data: CreateSessionResponse | {};
  openWindow: (response: CreateSessionResponse | {}) => void;
  addMore: Function;
  selectedPhotosCount: number;
};

const GoogleDialogInline = ({
  isGoogle,
  open,
  data,
  openWindow,
  addMore,
  selectedPhotosCount,
}: GoogleDialogInlineProps) => {
  const {t} = useTranslation();

  return open ? (
    <>
      <div className="flex flex-col justify-center gap-lg p-lg md:p-xxl items-center">
        <img
          src={GPDesktopImage}
          alt={t('str_TitleExternalUploadPictureUploader', {
            ns: 'uploadexternalassets',
          })}
          className="self-center h-[150rem]"
        />
        <Button
          label={t('str_TitleSelectPictures', {
            ns: 'uploadexternalassets',
          })}
          buttonStyle="secondary"
          onClick={e => openWindow(data as CreateSessionResponse)}
          className={'mt-auto w-[300px]'}
          startIcon={<ExpandBoxIcon />}
        />
      </div>
    </>
  ) : (
    <div className="flex justify-center">
      {selectedPhotosCount > 0 && isGoogle ? (
        <Button
          label={t('str_ButtonAddMorePictures')}
          buttonStyle={'distinct'}
          labelAlignment={'left'}
          onClick={e => addMore()}
          startIcon={<GooglePhotosIcon />}
          className={'inline-flex'}
        />
      ) : null}
    </div>
  );
};

export default GoogleDialogInline;
